import React from 'react';
import get from 'lodash.get';

import { extractTermPaths, TAX_CONSTANTS } from 'lib/taxonomy';
import { getCanonical } from 'lib/urlUtils';

import Recommended from 'components/Recommended';
import { RecircBody as MsnbcDailyRecirc } from 'components/MsnbcDaily/Recirc/Body';

function getRecommendationComponent(item, i) {
  const hideRecommendations = get(item, ['content', 'presentation', 'hideRecommendations'], false);
  if (hideRecommendations) {
    return null;
  }

  const {
    content: {
      taxonomy,
      url,
    } = {},
    mobile,
  } = item;

  const termPaths = extractTermPaths(taxonomy);

  // MSNBC vertical and MSNBC Opinion taxonomy
  if (termPaths.includes(TAX_CONSTANTS.MSNBC.VERTICAL)
    && termPaths.includes(TAX_CONSTANTS.MSNBC.SECTION_OPINION)) {
    // Show single MSNBC in-body recommendation unit
    if (mobile) {
      return <MsnbcDailyRecirc key={i} />;
    }
    return null;
  }

  return (
    <Recommended
      key={i}
      mobile={mobile}
      taxonomy={taxonomy}
      url={getCanonical(url)}
    />
  );
}

export { getRecommendationComponent };
